import {useQuery} from "@tanstack/react-query";

import {incidentsService} from "../services";

export default function useIncidentReport(incidentReportId: number | undefined | null) {
  const {data, isSuccess, isPending, isError, error} = useQuery({
    queryKey: ["incidentReport", {incidentReportId}],
    queryFn: () => incidentsService.getIncidentReport(incidentReportId!),
    enabled: Boolean(incidentReportId),
    retry: false,
  });

  const incidentReport = incidentReportId && isSuccess && data != null ? data : null;

  return {
    incidentReport,
    isSuccess,
    isPending: Boolean(incidentReportId && isPending),
    isError,
    error,
  };
}
